import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=88ae98aa&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=88ae98aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ae98aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88ae98aa')) {
      api.createRecord('88ae98aa', component.options)
    } else {
      api.reload('88ae98aa', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=88ae98aa&scoped=true", function () {
      api.rerender('88ae98aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/templateGroupManage/previewFrom/preview.vue"
export default component.exports